module.exports = __webpack_public_path__ + "static/media/wave-light.76fe200f.svg";